/**
 * Etiquetas de usuario para UI: nombre completo si existe, si no email.
 *
 * Los datos vienen de `profiles` (email/nombre/apellido, poblados en el
 * signup y expuestos por la vista `users_with_permissions`).
 */

/** "Nombre Apellido" normalizado, o null si no hay ninguno de los dos. */
export function nombreCompleto(
  nombre?: string | null,
  apellido?: string | null,
): string | null {
  const completo = [nombre?.trim(), apellido?.trim()]
    .filter((parte): parte is string => !!parte)
    .join(' ');
  return completo || null;
}

/** Etiqueta preferida: nombre completo → email → fallback. */
export function usuarioLabel(
  nombre?: string | null,
  apellido?: string | null,
  email?: string | null,
  fallback?: string | null,
): string | null {
  return nombreCompleto(nombre, apellido) ?? email ?? fallback ?? null;
}
